import React, { useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import {
  IRowMeta,
  setCohortRowSamplePercentage,
} from '../../../../redux/slices/oldBuilder';
import { builderCohortSamplePercentageSelector } from '../../../../redux/selectors/builder';
import SamplePercentageMenu from '../../BuilderFields/BuilderSamplePercentage/SamplePercentageMenu';

interface IProps {
  rowMeta: IRowMeta;
}

const CohortRowSamplePercentage = ({ rowMeta }: IProps) => {
  const dispatch = useAppDispatch();

  const curSamplingRateSelector = useMemo(
    builderCohortSamplePercentageSelector,
    [],
  );
  const curSamplingRate = useAppSelector((state) =>
    curSamplingRateSelector(state, rowMeta),
  );

  const handleChange = (newValue: number) => {
    dispatch(setCohortRowSamplePercentage({ newValue, rowMeta }));
  };

  return (
    <SamplePercentageMenu value={curSamplingRate} onChange={handleChange} />
  );
};

export default CohortRowSamplePercentage;
